import React from 'react'
import Header from '../Components/Component/Header'
import Blog_DT_BG from '../Components/Component/Blog_DT_BG'
import Blog_Comment from "../Components/Component/Blog_Comment"
import Footer from '../Components/Component/Footer'
const Blog_Details = () => {
  return (
    <div>

<Blog_DT_BG />

<Footer />
    </div>
  )
}

export default Blog_Details